import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type WorkspaceRole = 'Owner' | 'Admin' | 'Agent';

export interface WorkspaceItem {
  id: string;
  name: string;
  role: WorkspaceRole;
}

interface WorkspaceState {
  activeWorkspaceId: string | null;
  workspaces: WorkspaceItem[];
  currentRole: WorkspaceRole | null;
  setWorkspace: (workspaceId: string) => void;
  setWorkspaces: (workspaces: WorkspaceItem[]) => void;
  clearWorkspaceState: () => void;
}

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set, get) => ({
      activeWorkspaceId: null,
      workspaces: [],
      currentRole: null,

      setWorkspace: (workspaceId: string) => {
        const workspace = get().workspaces.find((w) => w.id === workspaceId);
        set({
          activeWorkspaceId: workspaceId,
          currentRole: workspace ? workspace.role : null,
        });
      },

      setWorkspaces: (workspaces: WorkspaceItem[]) => {
        const { activeWorkspaceId } = get();
        // If active workspace is not in the new list, or no active workspace is set, pick the first one
        const activeExists = workspaces.some((w) => w.id === activeWorkspaceId);
        let newActiveId = activeWorkspaceId;
        
        if (!activeExists && workspaces.length > 0) {
          newActiveId = workspaces[0].id;
        } else if (workspaces.length === 0) {
          newActiveId = null;
        }

        const activeWorkspace = workspaces.find((w) => w.id === newActiveId);

        set({
          workspaces,
          activeWorkspaceId: newActiveId,
          currentRole: activeWorkspace ? activeWorkspace.role : null,
        });
      },

      clearWorkspaceState: () => {
        set({
          activeWorkspaceId: null,
          workspaces: [],
          currentRole: null,
        });
      },
    }),
    {
      name: 'chatagent_workspace',
    }
  )
);
